module.exports = __webpack_public_path__ + "static/media/picture-(115).fbf2909e.JPG";